import React from 'react'
import exact from 'prop-types-exact'
import { BriefCaseIcon } from 'components/icons'

const propTypes = {}

const defaultProps = {}

function VendorIndicator() {
  return (
    <div className="flex-horizontal open-to-partnerships">
      <div className="star-icon">
        <BriefCaseIcon aria-hidden />
      </div>
      <p>
        <strong>Vendor</strong>
      </p>
    </div>
  )
}

VendorIndicator.propTypes = exact(propTypes)
VendorIndicator.defaultProps = defaultProps

export default React.memo(VendorIndicator)
